var map = {
	"./border-bg-sm.png": 1386,
	"./border-bg.png": 1387,
	"./btn-active.png": 1388,
	"./cny-flower-1.webp": 1389,
	"./cny-flower-2.webp": 1390,
	"./cny-mobile-bg.webp": 1391,
	"./content-deco-1.webp": 1392,
	"./content-deco-2.webp": 1393,
	"./content-deco-3.webp": 1394,
	"./content-deco-4.webp": 1395,
	"./content-deco-5.webp": 1396,
	"./deposit-icon.webp": 1397,
	"./home-icon-active.webp": 1398,
	"./home-icon.webp": 1399,
	"./live-icon-active.webp": 1400,
	"./live-icon.webp": 1401,
	"./master-bg.png": 1402,
	"./me-icon-active.webp": 1403,
	"./me-icon.webp": 1404,
	"./platform.webp": 1405,
	"./product-overview-bg.webp": 1406,
	"./promos-icon-active.webp": 1407,
	"./promos-icon.webp": 1408,
	"./sponsor-icon-active.webp": 1409,
	"./sponsor-icon.webp": 1410,
	"./title-deco-bg.webp": 1411,
	"./title-deco-left.webp": 1412,
	"./title-deco-right.webp": 1413,
	"./vip-icon-active.webp": 1414,
	"./vip-icon.webp": 1415,
	"./withdraw-icon.webp": 1416,
	"./wwr-bg.webp": 1417,
	"./wwr-img.webp": 1418
};


function webpackContext(req) {
	var id = webpackContextResolve(req);
	return __webpack_require__(id);
}
function webpackContextResolve(req) {
	if(!__webpack_require__.o(map, req)) {
		var e = new Error("Cannot find module '" + req + "'");
		e.code = 'MODULE_NOT_FOUND';
		throw e;
	}
	return map[req];
}
webpackContext.keys = function webpackContextKeys() {
	return Object.keys(map);
};
webpackContext.resolve = webpackContextResolve;
module.exports = webpackContext;
webpackContext.id = 148;